module.exports = __webpack_public_path__ + "ead024a298355e25e7b4e24349fc6cf6.pdf";